import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  AUTH_TOKEN,
  AUTH_NAME,
  AUTH_ROLE,
  AUTH_ROLE_ID,
  AUTH_USER_ID,
  AUTH_STUDENT_ID,
  AUTH_TEACHER_ID,
  AUTH_CURRENT_SESSION,
  AUTH_CURRENT_SESSION_TITLE,
  AUTH_CURRENT_SESSION_EMAILADDRESS,
  AUTH_CURRENT_DATA,
} from "constants/AuthConstant";
import FirebaseService from "services/FirebaseService";
// import { signInUserData } from 'mock/data/authData';

import AuthService from "services/AuthService";

export const initialState = {
  loading: false,
  message: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
};

export const signIn = createAsyncThunk(
  "auth/signIn",
  async (data, { rejectWithValue }) => {
    const { emailaddress, password } = data;
    try {
      const response = await AuthService.login({ emailaddress, password });

      const user = response?.data?.data;
      if (user && user.token) {
        localStorage.setItem(AUTH_CURRENT_SESSION, user.academicSessionId);
        localStorage.setItem(AUTH_TEACHER_ID, user.teacherId);
        localStorage.setItem(AUTH_STUDENT_ID, user.studentId);
        localStorage.setItem(AUTH_TOKEN, user.token);
        localStorage.setItem(AUTH_NAME, user.userName || user.firstName);
        const defaultRole =
          user.role && user.role.length > 0 ? user.role[0] : null;
        if (defaultRole) {
          localStorage.setItem(AUTH_ROLE, defaultRole.role);
          localStorage.setItem(AUTH_ROLE_ID, defaultRole.roleId);
        }
        localStorage.setItem(AUTH_USER_ID, user.id);
        return user.token;
      } else {
        return rejectWithValue("Invalid credentials. Please try again!");
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const signInUsingStudentLogin = createAsyncThunk(
  "auth/signIn",
  async (data, { rejectWithValue }) => {
    console.log(data);
    const { Studentid, password } = data;
    console.log(data);
    try {
      const response = await AuthService.loginUsingStudentid({ Studentid, password });
      console.log(response);
      
      const user = response?.data;
      if (user && user.token) {
        localStorage.setItem(AUTH_CURRENT_SESSION, user?.academicSessionId);
        localStorage.setItem(AUTH_CURRENT_DATA, JSON.stringify(user));        
        localStorage.setItem(AUTH_TEACHER_ID, user?.teacherId);
        localStorage.setItem(AUTH_STUDENT_ID, user?.studentId);
        localStorage.setItem(AUTH_TOKEN, user?.token);
        localStorage.setItem(AUTH_NAME, user?.userName || user?.firstName);
        const defaultRole =
          user?.role && user?.role?.length > 0 ? user?.role[0] : null;
        if (defaultRole) {
          localStorage.setItem(AUTH_ROLE, defaultRole?.role);
          localStorage.setItem(AUTH_ROLE_ID, defaultRole?.roleId);
        }
        localStorage.setItem(AUTH_USER_ID, user?.id);
        return user?.token;
      } else {
        return rejectWithValue("Invalid credentials. Please try again!");
      }
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const signOut = createAsyncThunk("auth/signOut", async () => {
  const response = await FirebaseService.signOutRequest();
  localStorage.clear();

  return response.data;
});

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticated: (state, action) => {
      state.loading = false;
      state.redirect = "/";
      state.token = action.payload;
    },
    showAuthMessage: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideAuthMessage: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    signOutSuccess: (state) => {
      state.loading = false;
      state.token = null;
      state.redirect = "/";
    },
    showLoading: (state) => {
      state.loading = true;
    },
    signInSuccess: (state, action) => {
      state.loading = false;
      state.token = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(signIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(signIn.fulfilled, (state, action) => {
        state.loading = false;
        state.redirect = "/";
        state.token = action.payload;
      })
      .addCase(signIn.rejected, (state, action) => {
        state.message = action.payload;
        state.showMessage = true;
        state.loading = false;
      })
      .addCase(signOut.fulfilled, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      })
      .addCase(signOut.rejected, (state) => {
        state.loading = false;
        state.token = null;
        state.redirect = "/";
      });
  },
});

export const {
  authenticated,
  showAuthMessage,
  hideAuthMessage,
  signOutSuccess,
  showLoading,
  signInSuccess,
} = authSlice.actions;

export default authSlice.reducer;
